module.exports = __webpack_public_path__ + "img/commer.4dc432f2.png";